<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XY0Kdy/images/cover.jpg?1731429783827" alt="This image is the cover for the book Enchanted Cat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Enchanted Cat
      </h1>
      <p class="bookDescription body article font2">
        <p>From the temples of ancient Egypt to the homes of modern Witches, cats have long been associated with magick and mystery. Examining cat mythology and folklore from around the world and sprinkled with enchanting cat quotes from famous feline admirers throughout the ages, <i>The Enchanted Cat </i>is a must-read for any magickal cat fancier.</p><p>Witches, Pagans, and other magick-minded folks will love the dozens of charms, spells, and meditations included for working with feline power. A naming ceremony, lists of magickal cat names and correspondences, and spells and charms for your cat's collar are just a sampling of the feline-friendly magick inside. Cat astrology, tarot, and even a discussion of feline feng shui make <i>The Enchanted Cat </i>a uniquely magickal exploration of our enduring fascination with the feline mystique.</p><p><b>Winner of the 2007 Coalition of Visionary Resources Award for Best Magick/Shamanism Book </b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen Dugan
      </h2>
      
      <p class="authorDescription body article"><P>Ellen Dugan is the award-winning author of fifteen books, and is known as the "Garden Witch". A psychic-clairvoyant, she has been a practicing Witch for over thirty years. Well known for her candor and humor, she is a Master Gardener, and is the High Priestess of her Coven in the St. Louis area. Ellen teaches classes both online and across the country on Witchery, Psychic Protection, and Magick. She has contributed articles for over twelve years to Llewellyn's Magical Almanac, Witches Datebook, Sabbat Almanac, and Witches Calendar.</P><P>Ellen's popular magickal books have been translated into over ten foreign languages. When she's not working on her next book project, or keeping up with her family (the kids are out on their own, and the youngest is in Graduate school), Ellen likes to unwind by working in her perennial gardens at home with her husband of 31 years. Ellen wholeheartedly encourages folks to reclaim their personal power and to personalize their Spell-craft. To go outside and connect with the spiritual side of nature. To get their hands dirty and discover the wonder and magick of natural world that surrounds them.</P><P>Visit her popular syndicated "Blog of Witchery" at www.ellendugan.blogspot.com </P><P>You can visit her website at www.ellendugan.com</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f6ed294